import { useEffect, useState } from 'react'
import emailParser from 'email-addresses'
import { queryParams } from 'util/params'
import { doSearchRecipients } from 'ducks/drafts'
import { useDispatch, useSelector } from 'react-redux'
import { selectDraftIdByTicketId } from 'ducks/drafts2/selectors'
import { doUpsertReplyDraft } from 'ducks/drafts2/operations/doUpsertReplyDraft'

export default function useQueryParamToRecipientLoader() {
  const [fetching, setFetching] = useState(true)
  const dispatch = useDispatch()

  const draftId = useSelector(state =>
    selectDraftIdByTicketId(state, 'new', 'reply')
  )

  useEffect(
    () => {
      const updateRecipients = async () => {
        const params = queryParams()
        if (!params.to) {
          setFetching(false)
          return
        }

        if (params.to) {
          const parsed = emailParser.parseAddressList({
            input: params.to,
            rejectTLD: true,
          })
          if (parsed && parsed[0]) {
            const item = parsed[0]
            const recipients = await dispatch(
              doSearchRecipients('enduser', item.address)
            )
            const foundRecipient = (recipients?.contacts || []).find(
              recipient => {
                return recipient.email === item.address
              }
            )
            if (foundRecipient) {
              dispatch(
                doUpsertReplyDraft(draftId, 'reply', 'new', null, {
                  to: [foundRecipient],
                })
              )
            }
          }
        }
        setFetching(false)
      }
      updateRecipients()
    },
    [dispatch, setFetching, draftId]
  )

  return fetching
}
